import React from 'react';
import { CTAButton } from './CTAButton';
import { benefits } from '../data/salesCopy';
export function BenefitsSection() {
  return <section className="bg-brand-sand px-4 py-8 sm:py-10" data-id="element-20" data-mp="bpbwkh5haqm">
      <div className="mx-auto max-w-4xl" data-id="element-21" data-mp="3iqq6joq1ikvu">
        <div className="text-center" data-id="element-22" data-mp="3ipoq14q9966q">
          <h2 className="font-serif text-2xl font-bold uppercase leading-[1.1] text-brand-brown sm:text-4xl" data-id="element-23" data-mp="3npb39e632mfj">
            Ce n’est pas simplement un autre ebook sur le Yin Yoga
          </h2>
          <p className="mt-2 font-serif text-lg font-bold uppercase tracking-wide text-brand-sage sm:text-2xl" data-id="element-24" data-mp="3dr3rd9qniuke">
            C’est un système visuel complet pour vos cours.
          </p>
          <span className="mx-auto mt-2 block h-0.5 w-14 bg-brand-gold" data-id="element-25" data-mp="2ztf3dt1af7b4" />
        </div>

        <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-26" data-mp="34qp444u4n5e9">
          {benefits.map(b => <li key={b.title} className="flex h-full flex-col rounded-lg bg-brand-ivory p-3" data-id="element-27" data-mp="xy4uxqp86gga">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-28" data-mp="2bedzpgakboc0">
                {b.icon}
              </span>
              <h3 className="mt-1.5 font-sans text-[13px] font-bold uppercase leading-tight tracking-wide text-brand-brown" data-id="element-29" data-mp="27csumh49secd">
                {b.title}
              </h3>
              <p className="mt-1 text-[12.5px] font-medium leading-snug text-brand-brown/80" data-id="element-30" data-mp="2g5dzctb2gki7">
                {b.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-5 flex justify-center" data-id="element-31" data-mp="1oepzdkl4pl64">
          <CTAButton data-id="element-32" data-mp="1og1ay6ktfx7s">🧘 Oui ! Je veux le système complet</CTAButton>
        </div>
      </div>
    </section>;
}